import "./About.css";
import about from "../../assets/about.jpg";

export default function About() {
  return (
    <section id="about" className="about container">
      <h2 className="section-title"><span className="yellow">À propos</span> de nous</h2>

      <div className="about-content">
        <img src={about} alt="Nettoyage" />

        <p>
          CLEAN SERVICE PRO est une société de nettoyage basée à Marseille, spécialisée dans l'entretien professionnel et le nettoyage complet de tous types de locaux. <br />
Nous mettons notre savoir-faire et notre rigueur au service des copropriétés, entreprises, administrations et particuliers afin de garantir des espaces propres, sains et agréables au quotidien. <br />
Notre équipe qualifiée intervient avec du matériel professionnel et des produits respectueux de l'environnement pour offrir un résultat irréprochable à chaque prestation. <br />
        </p>
      </div>
    </section>
  );
}